import api from './api';
const businessTypeService = {
  getBusinessType() {
    return api.get('/businesstype');
  },
  getBusinessTypeByIndustry(industryId: number) {
    const endpoint = `/businesstype/${industryId}`;
    return api.get(endpoint);
  },
  getBusinessItemByType(typeId: number | string, region_id: number) {
    let endpoint = '';
    if (typeId.toString().length > 0) {
      endpoint = `/region?region_id=${region_id}&business_type_id=${typeId}`;
    } else {
      endpoint = `/region?region_id=${region_id}`;
    }
    return api.get(endpoint);
  },
  deleteBusinessList(id: number) {
    const endpoint = `/businesslist/${id}`;
    return api.delete(endpoint);
  }
};

export default businessTypeService;